import api from "./api";

export const createPublicSupportTicket = async (payload) => {
    const res = await api.post("/public/support/tickets", payload);
    return res.data;
};